// Entry point for the build script in your package.json
import { Turbo } from "@hotwired/turbo-rails"
import "./controllers"
import { init, identify, trackPageView } from "./lib/mixpanel"
import { styledConfirm } from "./lib/turbo_confirm"

// Replace Turbo's native window.confirm with a styled modal app-wide,
// so every `data-turbo-confirm` gets a proper dialog (project
// convention: never browser confirm()). Importing Turbo directly
// targets the exact config object FormSubmission reads.
try {
  if (Turbo?.config?.forms) {
    Turbo.config.forms.confirm = (message, formEl, submitter) => styledConfirm(message, submitter || formEl)
  } else if (typeof Turbo?.setConfirmMethod === "function") {
    Turbo.setConfirmMethod((message, formEl, submitter) => styledConfirm(message, submitter || formEl))
  }
} catch (_e) { /* leave native confirm as fallback */ }

// ── Mixpanel analytics ──────────────────────────────────────────────────
// turbo:load fires on BOTH the initial page load and subsequent Turbo navigations,
// so a single listener handles everything without double-firing.
document.addEventListener("turbo:load", () => {
  const config = window.__mixpanelConfig
  if (!config || !config.token) return

  init(config.token)
  identify(config.userId, config.user, config.company, config.masquerade)
  trackPageView(document.title)
})
